// @flow
import React, { Component } from 'react';
import { isBrowser } from 'react-device-detect';
import Button from 'components/common/Button';
import { type Profile } from 'store/modules/profile';
import { BaseActions } from 'store/actionCreators';

import './SettingProfile.scss';

type Props = {
  profile: Profile,
  user: any,
  onUpdateProfile: ({
    managerName: string,
    displayName: string,
    shortBio: string,
    mobile: string,
    bizNumber: string,
  }) => any,
  onUploadThumbnail: () => any,
  onUploadBizFile: () => any,
};

type State = {
  editing: boolean,
  managerName: string,
  displayName: string,
  shortBio: string,
  mobile: string,
  bizNumber: string,
};

class SettingProfile extends Component<Props, State> {
  state = {
    editing: false,
    managerName: '',
    displayName: '',
    mobile: '',
    bizNumber: '',
  };

  constructor(props: Props) {
    super(props);
    const { profile } = this.props;
    this.state.managerName = profile.manager_name;
    this.state.displayName = profile.display_name;
    this.state.shortBio = profile.short_bio;
    this.state.mobile = profile.mobile;
    this.state.bizNumber = profile.biz_number;
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevProps.profile !== this.props.profile || (!prevState.editing && this.state.editing)) {
      const { manager_name, display_name, mobile, biz_number } = this.props.profile;
      this.setState({
        managerName: manager_name,
        displayName: display_name,
        mobile,
        bizNumber: biz_number,
      });
    }
  }

  onToggleEdit = (e: SyntheticEvent<*>) => {
    e.preventDefault();
    // this.setState({
    //   editing: !this.state.editing,
    // });
  };
  onChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  onSubmit = async (e: SyntheticEvent<*>) => {
    e.preventDefault();
    const { managerName, displayName, mobile, bizNumber } = this.state;
    try {
      await this.props.onUpdateProfile({
        managerName,
        displayName,
        mobile,
        bizNumber,
      });
      // this.setState({
      //   editing: false,
      // });
      BaseActions.showToast({
        message: '프로필이 저장되었습니다.',
        type: 'success',
      });
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    const { profile, onUploadThumbnail, onUploadBizFile } = this.props;
    const { editing, managerName, displayName, shortBio, mobile, bizNumber } = this.state;
    return (
      <div className="SettingProfile">
        <form onSubmit={this.onSubmit}>
          {/* <div className="thumbnail-area">
            <strong>회사 로고 사진</strong>
            <button type="button" onClick={onUploadThumbnail}>
              <img
                src={profile.thumbnail || 'https://images.cacheby.com/default_thumbnail.png'}
                alt="thumbnail"
              />
            </button>
          </div> */}
          <div className="grade">
            <strong>회원등급</strong>
            <span>{this.props.user.grade.name}</span>
          </div>
          <div className="email-change">
            <strong>이메일</strong>
            <span>{this.props.user.email}</span>
          </div>
          <div className="password-name">
            <strong>비밀번호</strong>
            <Button to={'/settings/password'}>비밀번호 변경</Button>
          </div>
          <div className="mobile">
            <strong>핸드폰 번호</strong>
            <input
              onChange={this.onChange}
              name="mobile"
              placeholder="핸드폰 번호"
              value={mobile}
              maxLength="40"
              required
            />
          </div>
          <div className="manager-name">
            <strong>이름</strong>
            <input
              onChange={this.onChange}
              name="managerName"
              placeholder="이름"
              value={managerName}
              maxLength="25"
              required
            />
          </div>
          <div className="display-name">
            <strong>회사 이름</strong>
            <input
              onChange={this.onChange}
              name="displayName"
              placeholder="회사 이름"
              value={displayName}
              maxLength="25"
              required
            />
          </div>
          <div className="biz-number">
            <strong>사업자 등록 번호</strong>
            <input
              onChange={this.onChange}
              name="bizNumber"
              placeholder="사업자 등록 번호"
              value={bizNumber}
              maxLength="40"
            />
          </div>
          <div className="biz-file">
            <strong>사업자 등록증 업로드</strong>
            <Button type="button" onClick={onUploadBizFile}>
              업로드
            </Button>
            {profile.biz_file && <a className="bizLink" href={profile.biz_file} target="_blank">사업자 등록증 보기</a>}
          </div>
          <div className="right">
            <Button theme='outline' color='blue' type="submit" desktop={isBrowser}>
              회원 정보 수정
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default SettingProfile;



// WEBPACK FOOTER //
// ./src/components/settings/SettingProfile/SettingProfile.js